import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { Lot, LotMouvement } from "../../models/lot.model";
import { environment } from "../../../../../environments/environment";
import { AuditReport } from "../../models/audit.model";
import { QuickInventairePayload } from "../../models/quick-inventaire.model";

@Injectable({ providedIn: "root" })
export class LotApiService implements EntityApiService<Lot> {
  loadOne(id: string): Observable<Lot> {
    return this.httpClient.get<Lot>(`${environment.api()}/lots/id/${id}`);
  }

  loadOneLight(id: string): Observable<Lot> {
    return this.httpClient.get<Lot>(`${environment.api()}/lots/id/${id}/light`);
  }

  httpClient = inject(HttpClient);

  create(entity: Lot): Observable<Lot> {
    throw new Error("Method not implemented.");
  }

  createLot(lotMouvement: LotMouvement): Observable<Lot> {
    return this.httpClient.post<Lot>(
      `${environment.api()}/lot_mouvements/create_lot`,
      lotMouvement,
    );
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: Lot): Observable<Lot> {
    return this.httpClient.post<Lot>(`${environment.api()}/lots`, entity);
  }

  loadAll(): Observable<Lot[]> {
    throw new Error("Method not implemented.");
  }

  loadForArticle(articleId: string): Observable<Lot[]> {
    return this.httpClient.get<Lot[]>(
      `${environment.api()}/lots/article/${articleId}`,
    );
  }

  loadUniqueForArticle(articleId: string): Observable<Lot> {
    return this.httpClient.get<Lot>(
      `${environment.api()}/lots/unique/${articleId}`,
    );
  }

  loadLightForArticle(articleId: string): Observable<Lot[]> {
    return this.httpClient.get<Lot[]>(
      `${environment.api()}/lots/article/${articleId}/light`,
    );
  }

  loadLightStockForArticle(articleId: string): Observable<Lot[]> {
    return this.httpClient.get<Lot[]>(
      `${environment.api()}/lots/article/${articleId}/light_stock`,
    );
  }

  updateDocumentListeId(lotId: string, documentListeId: string) {
    return this.httpClient.post<Lot>(
      `${environment.api()}/lots/update_documentListId/id/${lotId}/listeId/${documentListeId}`,
      null,
    );
  }

  fusionnerLots(articleId: string): Observable<Lot> {
    return this.httpClient.post<Lot>(
      `${environment.api()}/lot_mouvements/traite_rapprochement/${articleId}`,
      null,
    );
  }

  getAudit(lotId: string): Observable<AuditReport> {
    return this.httpClient.get<AuditReport>(
      `${environment.api()}/audit/lot/id/${lotId}`,
    );
  }

  makeAMove(lotMouvement: LotMouvement) {
    return this.httpClient.post(
      `${environment.api()}/lot_mouvements/move`,
      lotMouvement,
    );
  }

  quickInventaire(payload: QuickInventairePayload) {
    return this.httpClient.post(
      `${environment.api()}/lot_mouvements/quick_inventaire`,
      payload,
    );
  }
}
